export default "__VITE_ASSET__C9HZg_ZV__"